module.exports = __webpack_public_path__ + "static/media/1006996.ced23f57.jpg";